import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TblLeadConditions } from 'src/app/shared/models/LeadConditions';
import { LeadConditionsService } from 'src/app/shared/services/leadconditionservice';
import { LeadSourceService } from 'src/app/shared/services/leadsource.services';
import { UserServices } from 'src/app/shared/services/userservices';
import { NotificationService } from 'src/app/notification.service';
import { Observable } from 'rxjs';
import { TblUser } from 'src/app/shared/models/user';
import { TblLeadSources } from 'src/app/shared/models/leadsources';

@Component({
  selector: 'app-edit-lead-condition-dialog',
  templateUrl: './edit-lead-condition-dialog.component.html',
  styleUrls: ['./edit-lead-condition-dialog.component.css']
})
export class EditLeadConditionDialogComponent implements OnInit {
  model: TblLeadConditions;
  users: Observable<TblUser[]>;
  sources: Observable<TblLeadSources[]>;

  constructor(
    public dialogRef: MatDialogRef<EditLeadConditionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private leadConditionsService: LeadConditionsService,
    private leadSourceService: LeadSourceService,
    private userService: UserServices,
    private notifyService: NotificationService
  ) {
    this.model = data.model || new TblLeadConditions();
  }

  ngOnInit(): void {
    this.users = this.userService.getAllUsers();
    this.sources = this.leadSourceService.getAllLeadSource();
    
    if (this.data.isEditing && this.data.id) {
      this.leadConditionsService.getAllLeadConditionsById(this.data.id).subscribe(
        resp => {
          this.model = resp;
        }
      );
    } else {
      this.model.leadsAtATime = "1";
    }
  }

  assignLeadTypeChanged(event: any) {
    // Handle assignment type change if needed
  }

  validateForm(): boolean {
    if (!this.model.conditionName) {
      this.notifyService.showError("Condition Name can not be empty!", "Error");
      return false;
    }
    return true;
  }

  onSave() {
    if (!this.validateForm()) {
      return;
    }

    this.leadConditionsService.saveAllLeadConditions(this.model).subscribe(
      resp => {
        if (resp.refNo > 0) {
          this.notifyService.showSuccess(
            this.data.isEditing ? "Updated Successfully!" : "Saved Successfully!",
            "Success"
          );
          this.dialogRef.close({ action: 'save', model: this.model });
        } else {
          this.notifyService.showError(resp.message, "Error");
        }
      },
      err => {
        this.notifyService.showError(err, "Error");
      }
    );
  }

  onCancel() {
    this.dialogRef.close();
  }
}
